import { BeatLoader } from './BeatLoader';
import { BEAT_PATTERNS } from '../../../src/constants/danceLoaders';

// boom - chick - chick: heavy downbeat, two light offbeats
export function ZoukLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.zouk} />;
}
